import { render } from "./Import.vue?vue&type=template&id=152219ba&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=152219ba&scoped=true&lang=css"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152219ba"]])

export default __exports__